"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isSchedulePhase(object) {
    return checkSchedulePhase(object).fulfilled;
}
exports.isSchedulePhase = isSchedulePhase;
function checkSchedulePhase(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("projectId"), __1.hasNumber("startDate").integer(), __1.hasNumber("endDate").integer(), __1.hasNumber("createdTimestamp").integer(), __1.hasString("statusId").optional().nullable()).withOptions(options).explain();
}
exports.checkSchedulePhase = checkSchedulePhase;
//# sourceMappingURL=SchedulePhase.js.map